export default "__VITE_ASSET__DFD2GDni__"